import { RootState } from 'src/store';

export const getEngineApiTokensModal = (state: RootState) => state.admin.engineApiTokens.modal;
